import { ButtonLooks, FontIcons, StandardButton } from '@brandfolder/react';
import React, { FunctionComponent, useState } from 'react';

import { BrandguideCreateForm } from '@components/brandguides/BrandguideCreateForm';
import { track as trackLogRocket, TrackedEvent } from '@helpers/logRocket';

import classes from './styles/brandguide-create-button.module.scss';

interface BrandguideCreateButtonProps {
  atOverBrandguideLimit: boolean;
}

export const BrandguideCreateButton: FunctionComponent<BrandguideCreateButtonProps> = ({ atOverBrandguideLimit }) => {
  const [open, setOpen] = useState(false);

  const triggerMailTo = (): void => {
    const element = document.createElement('a');
    element.setAttribute('target', '_blank');
    element.setAttribute('href', `mailto:support@brandfolder.com?subject=Upgrade Inquiry&body=I'd like to inquire about adding more Brandguides to ${BFG.org_name}.`);
    element.style.display = 'none';

    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleClick = (): void => {
    if (atOverBrandguideLimit) {
      triggerMailTo();
    } else {
      trackLogRocket(TrackedEvent.BrandguideCreateOpen);
      setOpen((prevState) => !prevState);
    }
  };

  return (
    <>
      <StandardButton
        className={classes.createButton}
        id="create-brandguide-button"
        look={ButtonLooks.TextSecondary}
        onClick={handleClick}
        onKeyUp={(e): void => {
          if (e.key === 'Enter') {
            handleClick();
          }
        }}
        startIcon={atOverBrandguideLimit ? undefined : FontIcons.Plus}
        startIconProps={{
          iconSize: 12
        }}
      >
        {atOverBrandguideLimit ? bfTranslate('Upgrade for Brandguides') : bfTranslate('New Brandguide')}
      </StandardButton>
      <BrandguideCreateForm
        open={open}
        organizationKey={BFG.organization_key}
        setOpen={setOpen}
      />
    </>
  );
};
